import { _axios } from "interceptor/http-config";

export const _AuthApi = {
  login: (data) => {
    return _axios
      .post("/admin/login", data)
      .then((res) => _AuthApi.storeToken(res?.data?.admin.token));
  },

  storeToken: (access_token) => {
    localStorage.setItem("access_token", access_token);
  },

  getToken: () => localStorage.getItem("access_token"),

  destroyToken: () => {
    localStorage.removeItem("access_token");
    window.location.reload();
  },

  changePass: (data) => {
    return _axios
      .post("/admin/password/update", data)
      .then((res) => alert("Password Changed"));
  },
};
